export function ApplicationFilter(job_id)
{
    let retainFilterData = JSON.parse(localStorage.getItem('filterData'));
    if(retainFilterData){
        retainFilterData = Object.fromEntries(Object.entries(retainFilterData).filter(([key, value]) => Array.isArray(value) ? value.length > 0 : value));
        if (retainFilterData && retainFilterData['job_id'] == parseInt(job_id)){
            delete retainFilterData['job_id']
            return retainFilterData
        }
    }
    else{
        return null;
    }
}